module.exports = __webpack_public_path__ + "img/upload-doc.d050d40c.svg";